import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Layout from "./layouts/Layout";

const App = () => {
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} limit={3} />
      <Layout>
        <Outlet />
      </Layout>
    </>
  );
};
export default App;
